import { useMediaQuery } from '@chakra-ui/react';
import { Constant } from '../../../../ui/theming/valuobject/constant.ts';

export interface MediaViewModel {
  isMobile: boolean;
  isNotMobile: boolean;
  isShort: boolean;
}

export default function useMediaViewModel(): MediaViewModel {
  const [isMobile] = useMediaQuery([`(max-width: ${Constant.MOBILE_BREAK_WIDTH}px)`]);
  const [isShort] = useMediaQuery([`(max-height: 700px)`]);

  return { isMobile, isNotMobile: !isMobile, isShort };
}
